import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";
import { startMicrosoftLogin, getRedirectUri } from "../authConfig";

const AuthContext = createContext(null);

const API = process.env.REACT_APP_BACKEND_URL;

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/api/auth/me`, { withCredentials: true });
      setUser(res.data);
      return true;
    } catch {
      setUser(null);
      return false;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  /** Kick off the Microsoft sign-in redirect. */
  const loginMicrosoft = useCallback(async () => {
    await startMicrosoftLogin();
  }, []);

  /**
   * Exchange a Microsoft authorization code for our backend session cookie.
   * Called from /auth/callback once Microsoft redirects back.
   */
  const exchangeCode = useCallback(async (code) => {
    const res = await axios.post(
      `${API}/api/auth/microsoft`,
      { code, redirectUri: getRedirectUri() },
      { withCredentials: true },
    );
    setUser(res.data.user);
    return res.data;
  }, []);

  const logout = useCallback(async () => {
    try {
      await axios.post(`${API}/api/auth/logout`, {}, { withCredentials: true });
    } catch (err) {
      console.error("Backend logout failed:", err);
    }
    setUser(null);
    window.location.assign("/login");
  }, []);

  return (
    <AuthContext.Provider
      value={{ user, loading, loginMicrosoft, exchangeCode, logout, checkAuth }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
